__webpack_require__.p = "/assets/appartement/frontend/";